var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{class:_vm.classProperties},[_vm._v(_vm._s(_vm.text)+" ")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }